module.exports = __webpack_public_path__ + "static/media/PastoralCare.b522745a.jpg";